import { twMerge } from 'tailwind-merge';
import { FC } from 'react';
import Input, { InputProps } from '../Input/Input';

export type InputWithIconProps = InputProps & {
  icon?: React.ReactNode;
};
const InputWithIcon: FC<InputWithIconProps> = ({ fullWidth = false, icon, className, disabled, value, ...rest }) => {
  return (
    <div className={twMerge('group relative', fullWidth && 'w-full')}>
      <div
        className={twMerge(
          'absolute top-[50%] translate-y-[-50%] pl-4',
          'text-white group-focus-within:text-white group-hover:text-white',
          !value && 'text-ph-white-30 group-hover:text-ph-white-50 group-hover:group-focus-within:text-white',
          disabled && 'cursor-not-allowed text-ph-white-10',
        )}
      >
        {icon}
      </div>
      <Input
        className={twMerge(icon && '!pl-12', className)}
        fullWidth={fullWidth}
        disabled={disabled}
        value={value}
        {...rest}
      />
    </div>
  );
};

export default InputWithIcon;
